import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends BaseService {
  createPayment(body, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.post('/v2/payment/ar', body)
      .subscribe(
        resp => {
          onSuccess(resp);
        },
        err => {
          if (onError) {
            onError(err);
          }
        });
  }

  cancelPayment(trxId, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.put(`/v2/user-transactions/${trxId}/cancel`)
      .subscribe(
        resp => {
          onSuccess(resp);
        },
        err => {
          if (onError) {
            onError(err);
          }
        });
  }
}
